import { ECardType, EPaymentMethod } from './config';
import { ParsedFeeDisclaimer, TClientFeesDisclaimers } from '../types';
import { tryParseJSONObject } from './jsonUtil';

export const parseFeesDisclaimers = (feesDisclaimersArr: TClientFeesDisclaimers[]): ParsedFeeDisclaimer[] => {
  return feesDisclaimersArr.map((feeDisclaimer) => {
    const feeObj = tryParseJSONObject(feeDisclaimer.disclaimer);
    const { key, data } = feeObj;
    const paramsArr = Object.values(data || {}) as string[];
    const disclaimer = key && key.startsWith('fees.') ? { key, data: paramsArr } : feeDisclaimer.disclaimer;
    return { ...feeDisclaimer, disclaimer };
  });
};

export const filterFeesByPaymentType = (
  feesDisclaimersArr: ParsedFeeDisclaimer[],
  paymentType: EPaymentMethod | undefined,
): ParsedFeeDisclaimer[] => {
  return !paymentType
    ? feesDisclaimersArr
    : feesDisclaimersArr.filter((feeDisclaimer) => (
      feeDisclaimer.paymentType.toLowerCase() === paymentType.toLowerCase()
    ));
};

export const filterFeesByCardType = (
  feesDisclaimersArr: ParsedFeeDisclaimer[],
  potentialCardType: ECardType | null,
): ParsedFeeDisclaimer[] => {
  return !potentialCardType
    ? feesDisclaimersArr
    : feesDisclaimersArr.filter((feeDisclaimer) => (
      feeDisclaimer.accountBrand === potentialCardType
    ));
};

export const getMaxFee = (
  feesDisclaimersArr: ParsedFeeDisclaimer[],
): ParsedFeeDisclaimer | null => {
  return feesDisclaimersArr.reduce((maxFeeDisclaimer, feeDisclaimer) => {
    if (!maxFeeDisclaimer ||
      (typeof maxFeeDisclaimer.disclaimer === 'object' &&
        typeof feeDisclaimer.disclaimer === 'object' &&
        Number(maxFeeDisclaimer?.disclaimer?.data?.[0]) < Number(feeDisclaimer.disclaimer.data?.[0]))) {
      maxFeeDisclaimer = feeDisclaimer;
    }
    return maxFeeDisclaimer;
  }, null as ParsedFeeDisclaimer | null);
};

export const checkAreDifferentFees = (
  feesDisclaimersArr: ParsedFeeDisclaimer[],
): boolean => {
  let maxFee = 0;

  return feesDisclaimersArr.length > 1 && feesDisclaimersArr.some((fee, i) => {
    if (typeof fee.disclaimer !== 'object' || !fee.disclaimer.data || isNaN(Number(fee.disclaimer.data?.[0]))) {
      return false;
    }

    if (i === 0) {
      maxFee = Number(fee.disclaimer.data[0]);
      return false;
    } else if (maxFee !== Number(fee.disclaimer.data[0])) {
      return true;
    }
  });
};
